import type { Distance } from "@pdfking/math"
import { ToMargins } from "@pdfking/math"
import { MM, ToPixel } from "@pdfking/quantity"
import { NullQ } from "@pdfking/structs"
import { Items, RecordCreate } from "@pdfking/tfunc"

import type { PdfEngineOptions } from "../../public/types/engine/PdfEngineOptions"

/** The engine's options, every field filled: `config` over the defaults. A
 * field `config` leaves undefined keeps its default — a caller handing over
 * every key it knows, set or not, never wipes one. */
export const CreatePdfEngineOptions = (config: Partial<PdfEngineOptions> = {}) =>
  ({
    chunk_size: 10485760, // 10mb
    file_bleed: ToMargins(MM(10)),
    file_cache: "pdfengine",
    image_dpi: 300,
    max_size: 2048,
    stroke_width: MM(0.1),
    tracking_chunk_size: 104857600, // 10mb
    unit_to_px: ToPixel(1 as Distance),
    ...(RecordCreate(Items(config).filter(([, value]) => !NullQ(value))) as typeof config),
  }) as PdfEngineOptions
